import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: () =>import('./views/Gallery.vue')
    },
    {
      path: '/stack-plan',
      name: 'stack-plan',
      component: () => import('./views/StackPlan.vue')
    },
    {
      path: '/floor-plan',
      name: 'floor-plan',
      component: () =>import('./views/FloorPlan.vue')
    },
    {
      path: '/amenities',
      name: 'amenities',
      component: () =>import('./views/Amenities.vue')
    },
    {
      path: '/neighborhood',
      name: 'neighborhood',
      component: () =>import('./views/Neighborhood.vue')
    },
    {
      path: '/inquiries',
      name: 'inquiries',
      component: () =>import('./views/Inquiries.vue')
    },
    {
      path: '/videolanding',
      name: 'videolanding',
      component: () =>import('./views/VideoLanding.vue')
    }
  ]
})
